import { render, staticRenderFns } from "./areaProductEdit.vue?vue&type=template&id=8a6fab6c&scoped=true&"
import script from "./areaProductEdit.vue?vue&type=script&lang=js&"
export * from "./areaProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./areaProductEdit.vue?vue&type=style&index=0&id=8a6fab6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fab6c",
  null
  
)

export default component.exports